import { useTranslation } from "react-i18next";
import {
  BenebonoFacebook,
  BenebonoInstagram,
  BenebonoLinkedin,
  LogoFooter,
} from "../../assets";
import Link from "next/link";

export default function RefreshedFooter({ links, locale }) {
  const { t } = useTranslation();
  const lang = locale || "fr";

  return (
    <footer>
      <h2 className="footer_title">{t("footer.title")}</h2>
      <div className="footer_socials">
        <div className="footer_socials__circle facebook">
          <a
            target="_blank"
            rel="noreferrer"
            href={
              lang === "es"
                ? "https://www.facebook.com/benebono.es/"
                : "https://www.facebook.com/benebono.fr/"
            }
          >
            <BenebonoFacebook />
          </a>
        </div>
        <div className="footer_socials__circle">
          <a
            target="_blank"
            rel="noreferrer"
            href={
              lang === "es"
                ? "https://www.instagram.com/benebono.es/"
                : "https://www.instagram.com/benebono.fr/"
            }
          >
            <BenebonoInstagram />
          </a>
        </div>
        <div className="footer_socials__circle">
          <a
            target="_blank"
            rel="noreferrer"
            href={
              lang === "es"
                ? "https://www.linkedin.com/company/benebono-fr"
                : "https://www.linkedin.com/company/benebono-fr"
            }
          >
            <BenebonoLinkedin />
          </a>
        </div>
      </div>

      <ul className="footer_links">
        {links?.map((l, i) => (
          <a key={i} href={l.href}>
            {l.label}
          </a>
        ))}
      </ul>

      <div className="footer_third_row">
        <ul className="footer_company_info">
          <li>Bene Bono® {new Date().getFullYear()}</li>
          <Link href="/policy">{t("footer.privacynotice")}</Link>

          <a
            href={
              lang !== "es"
                ? "https://static.horsnormes.co/static/legal/20241001-CGV-BeneBono.pdf"
                : "https://static.horsnormes.co/static/legal/CGV-spain.pdf"
            }
            target="_blank"
            rel="noreferrer"
          >
            {t("footer.conditionsofuse")}
          </a>
          <a
            href={
              "https://static.horsnormes.co/static/legal/20241001-BeneBono-MentionsLegales.pdf"
            }
            target="_blank"
            rel="noreferrer"
          >
            {t("footer.legal_mentions")}
          </a>
          <li>{t("footer.cookies")}</li>
        </ul>

        <div className="footer_logo">
          <LogoFooter />
        </div>

        <div className="footer_address">
          <div className="addresses">
            <p>{t("footer.email")}</p>
            {lang === "es" && <p>{t("footer.openhour")}</p>}
            {lang === "es" && <p>{t("footer.phonenumber")}</p>}
            <p>{t("footer.address")}</p>
          </div>
          <div className="certification">
            <p>{t("footer.certification")}</p>
            <p>{t("footer.certification.code")}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
